<template>
  <v-autocomplete
    ref="helperSearchInput"
    filled
    hide-details
    dense
    single-line
    prepend-inner-icon="fa-search"
    label="Recherche"
    class="no-before"
    :value="value"
    @change="v => $emit('input', v)"
    :items="getFilteredItems"
  >
    <template v-slot:item="data">
      <template>
        <v-list-item-content>
          <v-list-item-title v-html="data.item.text"></v-list-item-title>
        </v-list-item-content>
        <v-list-item-avatar>
          <v-icon
            :color="getIsAdmin === true ? 'success' : ''"
            style="opacity: 0.5;"
            v-if="data.item.admin === true"
            >fa-shield-alt</v-icon
          >
        </v-list-item-avatar>
      </template>
    </template>
  </v-autocomplete>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "HelperSearch",
  props: {
    value: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters(["getHelperTopics", "getIsAdmin"]),
    getFilteredItems() {
      if (this.getIsAdmin === true) {
        return this.getHelperTopics;
      } else {
        return this.getHelperTopics.map(x => {
          return {
            ...x,
            disabled: x.admin
          };
        });
      }
    }
  },
  methods: {
    focus() {
      this.$refs.helperSearchInput.focus();
    }
  }
};
</script>

<style></style>
